import React, { Component } from 'react'
import { Row, Col, Modal, Spin, Pagination } from 'antd'
import { app, api } from '../../app'
import '../../css/bn-video.css'
import Head from '../../components/Head'
import Footer from '../../components/Footer'

class BNVideo extends Component {
    constructor (props) {
        super(props)
        this.state = {
            preview_visible: false,
            player_loading: false,
            data_loading: false,
            preview_info: {},
            page: 1,
            total: 0,
            dataList: []
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.dataSource(1)
    }

    componentWillUnmount () {
        this._isMounted = false
        this.player = null
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据
     * @param page
     */
    dataSource = async (page) => {
        const state = { data_loading: true, dataList: [] }
        if (page) {
            state.page = page
        } else {
            page = this.state.page
        }
        await this.setData(state)
        let { flag, data, msg } = await app.post(api.BVideoList, { page })
        if (flag !== 1) {
            app.alert(msg, 'error')
            data = {}
        }
        if (page === this.state.page) {
            await this.setData({
                dataList: ((data.VideoList || {}).Video) || [],
                data_loading: false,
                total: data.Total || 0
            })

        }
    }

    /**
     * 打开播放
     **/
    handleOpenPlayer = async (info) => {
        await this.setData({ preview_visible: true, preview_info: info, player_loading: true })
        const { flag, data, msg } = await app.post(api.BVideoPlay, { video_id: info.VideoId })
        await this.setData({ player_loading: false })
        if (flag === 1) {
            const li = data.PlayInfoList.PlayInfo[0].Width / data.PlayInfoList.PlayInfo[0].Height
            const source = {}
            for (let i = 0; i < data.PlayInfoList.PlayInfo.length; i++) {
                source[data.PlayInfoList.PlayInfo[i].Definition] = data.PlayInfoList.PlayInfo[i].PlayURL
            }
            console.log(source)
            this.player = new window.Aliplayer({
                'id': 'bnv-video',
                'source': JSON.stringify(source),
                'defaultDefinition': 'SD',
                'width': '800px',
                'cover': info.cover_img,
                'height': (800 / li) + 'px',
                'autoplay': true,
                'isLive': false,
                'rePlay': false,
                'playsinline': true,
                'preload': true,
                'controlBarVisibility': 'hover',
                'useH5Prism': true,
                'extraInfo': {
                    'crossOrigin': 'anonymous'
                },
                'skinLayout': [
                    {
                        'name': 'bigPlayButton',
                        'align': 'blabs',
                        'x': 30,
                        'y': 80
                    },
                    {
                        'name': 'H5Loading',
                        'align': 'cc'
                    },
                    {
                        'name': 'errorDisplay',
                        'align': 'tlabs',
                        'x': 0,
                        'y': 0
                    },
                    {
                        'name': 'infoDisplay'
                    },
                    {
                        'name': 'tooltip',
                        'align': 'blabs',
                        'x': 0,
                        'y': 56
                    },
                    {
                        'name': 'thumbnail'
                    },
                    {
                        'name': 'controlBar',
                        'align': 'blabs',
                        'x': 0,
                        'y': 0,
                        'children': [
                            {
                                'name': 'progress',
                                'align': 'blabs',
                                'x': 0,
                                'y': 44
                            },
                            {
                                'name': 'playButton',
                                'align': 'tl',
                                'x': 15,
                                'y': 12
                            },
                            {
                                'name': 'timeDisplay',
                                'align': 'tl',
                                'x': 10,
                                'y': 7
                            },
                            {
                                'name': 'fullScreenButton',
                                'align': 'tr',
                                'x': 10,
                                'y': 12
                            },
                            {
                                'name': 'setting',
                                'align': 'tr',
                                'x': 15,
                                'y': 12
                            },
                            {
                                'name': 'volume',
                                'align': 'tr',
                                'x': 5,
                                'y': 10
                            }
                        ]
                    }
                ]
            })
        } else {
            app.alert(msg, 'error')
        }
    }

    render () {
        let { dataList, preview_visible, preview_info, page, total, player_loading, data_loading } = this.state
        return (
            <div className="bottom-nav-video">
                <div className="bnv-head">
                    <Head history={this.props.history} center height="auto"/>
                </div>
                <div className="bnv-content">
                    <h3 className="bnvc-title">存心救援视频展播</h3>
                    <Spin delay={200} spinning={data_loading} size="large">
                        <Row className="bnv-items" gutter={15}>
                            {
                                dataList.map((item, i) => {
                                    return (
                                        <Col span={6} key={i}>
                                            <div className="bnv-item">
                                                <div className="bnvi-video" onClick={() => this.handleOpenPlayer(item)}
                                                     title="点击播放">
                                                    <div className="bnvi-cover">
                                                        <img src={item.CoverURL} alt=""/>
                                                    </div>
                                                    {/*<div className="bnvi-icon">*/}
                                                    {/*<Icon type="play-circle"/>*/}
                                                    {/*</div>*/}
                                                </div>
                                                <div className="bnvi-title">{item.Title}</div>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                        <div className="bnv-page">
                            <Pagination hideOnSinglePage={true} current={page} total={total} pageSize={20}
                                        onChange={this.dataSource}/>
                        </div>
                    </Spin>
                </div>
                <Footer/>
                <Modal visible={preview_visible}
                       width="80%"
                       title={preview_info.Title}
                       footer={null}
                       zIndex={1002}
                       destroyOnClose={true}
                       centered={true}
                       bodyStyle={{
                           height: 720,
                           overflowY: 'auto'
                       }}
                       className="bottom-nav-video-modal"
                       onCancel={() => this.setData({ preview_info: {}, preview_visible: false })}>
                    <Spin delay={200} spinning={player_loading} style={{ height: 600 }}>
                        <div style={{ margin: '0 auto' }} className="prism-player" id="bnv-video"/>
                    </Spin>
                    <h3 style={{ lineHeight: '40px', fontWeight: '600' }}>{preview_info.Title}</h3>
                    <p>{preview_info.Description}</p>
                </Modal>
            </div>
        )
    }
}

export default BNVideo



// WEBPACK FOOTER //
// ./src/routes/bottomNav/BNVideo.jsx